import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import { useLayoutEffect } from "react";
import { updateTitle } from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import Footer from "../../component/footer/Footer";
import { ReactComponent as Logo } from "../../assets/logo_open_innovation.svg";
import { ReactComponent as Email } from "../../assets/email__icon.svg";

const OpenInnovation = () => {
  const mode = DisplayType();
  const { t } = useLanguage();

  useLayoutEffect(() => {
    updateTitle(t("program", "openInnovation.pageTitle"));
  }, [t]);

  return (
    <Container>
      <HeaderContainer>
        <Logo className="program__logo" />
        <span
          className={`program__title ${
            mode === "Mobile" ? "font-bold-24" : "font-title"
          }`}
        >
          {t("program", "openInnovation.title")}
        </span>
        <p
          className={`program__description ${
            mode === "Mobile" ? "font-body3" : "font-body2"
          }`}
        >
          {renderText(t("program", "openInnovation.desc"), mode)}
        </p>
      </HeaderContainer>
      <BodyContainer className="limit__body">
        <ProgramDescription>
          <div
            className={`program__description__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-title"
            }`}
          >
            {t("program", "openInnovation.descTitle")}
          </div>
          <p className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}>
            {t("program", "openInnovation.descBody1")}
            <br />
            <br />
            {renderText(t("program", "openInnovation.descBody2"), mode)}
          </p>
        </ProgramDescription>
        <ProgramProcess>
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "openInnovation.processTitle")}
          </div>
          <div className={`program__process__row`}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "openInnovation.descLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "openInnovation.descValue")}
            </span>
          </div>
          <div className={`program__process__row`} style={{ marginTop: 8 }}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "openInnovation.targetLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "openInnovation.targetValue")}
            </span>
          </div>
          <div className="program__process__list">
            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 1
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step1Title")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 2
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step2Title")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 3
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step3Title")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 4
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step4Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step4Desc")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 5
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step5Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step5Desc")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 6
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "openInnovation.step6Title")}
                </span>
              </div>
            </ProgramProcessItem>
          </div>
        </ProgramProcess>
        <ProgramProcess>
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "openInnovation.contactTitle")}
          </div>
          <span
            className={`item__descrition ${
              mode === "Mobile" ? "font-body3" : "font-body2"
            }`}
          >
            {t("program", "openInnovation.contactNotice")}
          </span>
          <a
            href="mailto:steve@bluepoint.ac"
            style={{ textDecoration: "none" }}
          >
            <EmailContainer>
              <Email className="email__icon" />
              <span
                className={`email__text ${
                  mode === "Mobile" ? "font-regular-16" : "font-regulra-22"
                }`}
              >
                steve@bluepoint.ac
              </span>
            </EmailContainer>
          </a>
        </ProgramProcess>
      </BodyContainer>
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 80px;

  @media only screen and (max-width: 768px) {
    padding-top: 60px;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-02);
  padding-top: 80px;
  padding-bottom: 80px;

  .program__logo {
    width: 240px;
    min-width: 240px;
    max-width: 240px;
    height: 240px;
    min-width: 240px;
    max-width: 240px;
  }
  .program__title {
    color: var(--black);
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .program__description {
    color: var(--grey-40);
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    padding-bottom: 60px;
    .program__logo {
      width: 117px;
      min-width: 117px;
      max-width: 117px;
      height: 117px;
      min-width: 117px;
      max-width: 117px;
    }
    .program__title {
      color: var(--black);
      margin-top: 24px;
      margin-bottom: 8px;
    }
  }
`;

const BodyContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  margin-bottom: 160px;
`;

const ProgramDescription = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__description__title {
    color: var(--primary);
    margin-bottom: 24px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__description__title {
      margin-bottom: 16px;
    }
  }
`;

const ProgramProcess = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__process__title {
    color: var(--black);
    margin-bottom: 24px;
  }

  .program__process__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .program__process__list {
    width: 100%;
    border-top: 1px solid var(--grey-00);
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__process__title {
      margin-bottom: 16px;
    }
    .program__process__row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
`;

const ProgramProcessItem = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--grey-00);
  gap: 312px;
  .program__process__item__column {
    display: flex;
    flex-direction: column;
  }

  .program__process__item__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    .program__process__item__title {
      width: 35px;
    }
  }
  .item__title {
    color: var(--primary);
  }
  .item__descrition {
    color: var(--grey-60);
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    padding: 24px 16px;

    .program__process__item__row {
      .program__process__item__title {
        width: 24px;
      }
    }
  }
`;

const EmailContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  .email__icon {
    width: 32px;
    height: 32px;
  }
  .email__text {
    color: var(--primary);
  }
`;
export default OpenInnovation;
